import { Button, Card, Col, Flex, Form, Input, Row, Space, Typography } from 'antd';
import React from 'react';

import {
  AssessmentStepPager,
  type AssessmentFlowStep,
} from '@/components/assessment/AssessmentStepPager';
import { NextIcon } from '@/icons';

export interface StepEditorProps {
  stepNumber: 1 | 2;
  assessmentLabel: string;
  onRunGenerate: () => void;
  onOpenOutput: () => void;
  /** When set, shows the 1/4 step pager in the header (assessment-instance flows). */
  onNavigateAssessmentStep?: (step: AssessmentFlowStep) => void;
}

const { Text } = Typography;

export const StepEditor: React.FC<StepEditorProps> = ({
  stepNumber,
  assessmentLabel,
  onRunGenerate,
  onOpenOutput,
  onNavigateAssessmentStep,
}) => {
  return (
    <Space direction="vertical" size="large" className="page-stack">
      <Card>
        <Flex vertical={false} align="flex-start" justify="space-between" gap={16} wrap="wrap">
          <Space direction="vertical" size="small" style={{ flex: '1 1 280px' }}>
            <Typography.Title level={4} style={{ margin: 0 }}>
              Step 0{stepNumber} - {assessmentLabel}
            </Typography.Title>
            <Text type="secondary">
              Populate fields and run generation to produce the next artifact.
            </Text>
          </Space>
          {onNavigateAssessmentStep ? (
            <AssessmentStepPager current={stepNumber} onStepChange={onNavigateAssessmentStep} />
          ) : null}
        </Flex>
      </Card>

      <Card>
        <Form layout="vertical">
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item label="Objective">
                <Input placeholder="Define the step objective" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Audience">
                <Input placeholder="Who will consume this output?" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Context">
            <Input.TextArea rows={6} placeholder="Provide additional context for generation..." />
          </Form.Item>
          <Space>
            <Button type="primary" icon={<NextIcon />} onClick={onRunGenerate}>
              Run Generation
            </Button>
            <Button onClick={onOpenOutput}>View Latest Output</Button>
          </Space>
        </Form>
      </Card>
    </Space>
  );
};

export default StepEditor;
